import React from 'react';
import { action, observable, computed } from 'mobx';

import store from '../../store';

const UPDATE_INTERVAL = 3000;

class VotingStore {
	
	@observable session = null;
	@observable error = null;
	@observable deputy = null;
	@observable chairman = null;
	@observable member = null;
	@observable members = [];
	@observable questions = [];

	@observable isLoading = false;
	@observable isDeleting = false;
	
	updateTimer = null;
	
	@action init = async (id) => {
		this.reset();

		this.id = parseInt(id);
		if (!this.id) {
			this.error = 'Не указан корректный ID.';
			return;
		}
		
		this.isLoading = true;
		try {
			await this.getSession();
			await this.getQuestions();
			await this.getMembers();
			this.updateStart = new Date().getTime();
			this.startUpdates();
		}
		catch(e) {
			console.error(e);
			this.error = e.message;
		}
		this.isLoading = false;
	};
	
	
	/** fetch data */
	
	getSession = async () => {
		this.session = await store.model.Session.findById(this.id, {
			include: ['chairman']
		});
	};
	
	getQuestions = async () => {
		this.questions = await this.session.questions.find({ order: 'order asc' });
	};
	
	getMembers = async () => {
		this.members = await store.model.SessionMember.find({ where: { sessionId: this.id }});
	};
	
	
	/** reset */

	@action reset = () => {
		this.session = null;
		this.error = null;
		this.deputy = null;
		this.chairman = null;
		this.member = null;
		this.members = [];
		this.questions = [];

		this.isLoading = false;
		this.isDeleting = false;
	};

	
	resetSession = async () => {
		this.isDeleting = true;
		const sessionId = this.session.id;
		const promises = [];
		
		let records = await store.model.SessionMember.find({ where: { sessionId }});
		promises.push(records.map(r => r.delete()))
		
		records = await store.model.SessionQuestionDiscussQueue.find({ where: { sessionId }});
		promises.push(records.map(r => r.delete()))
		
		records = await store.model.Vote.find({ where: { sessionId }});
		promises.push(records.map(r => r.delete()))
		
		records = await store.model.SessionQuestion.find({ where: { sessionId }});
		promises.push(records.map(r => r.delete()))
		
		promises.push(this.session.delete());
		
		await Promise.all(promises);
		
		// this.record.registrationStart = null;
		// this.record.chairman = null;
		// this.record.end = null;
		// await this.record.save();
		
		store.route.push({ path: '/admin/voting' });
	};
	
	
	/** update */
	
	update = async () => {
		const promises = [];
		promises.push(this.getMembers());
		await Promise.all(promises);
	};
	
	
	/** getters */
	
	@computed get quorum () {
		return this.members.length + 35 >= 36;
	}
	
	get timeFromStart () {
		return Math.round((new Date().getTime() - this.updateStart) / 1000);
	}
	

	/** timer */
	
	startUpdates = () => {
		this.stopUpdates();
		this.makeUpdate();
	};
	
	stopUpdates = () => {
		// console.log('stopUpdates at', this.timeFromStart);
		clearTimeout(this.updateTimer);
	};
	
	makeUpdate = async () => {
		clearTimeout(this.updateTimer);
		// console.log('updating...', this.timeFromStart);
		await this.update();
		this.updateTimer = setTimeout(this.makeUpdate, UPDATE_INTERVAL);
	};

	
	/** utils */

	fio = record => <>{record.lastName} {record.firstName} {record.middleName}</>;
	

	/** admin */
	
	startDiscussion = async question => {
		this.session.questionId = question.id;
		this.session.currentQuestion = question;
		await this.session.save();
	};
	
}

export default new VotingStore();
